import Container from "./Container"
const GridSpacer = ({width}) => <Container width={width}/>

export default GridSpacer